<script lang="ts">
  import { _ } from 'svelte-i18n';

  // @ts-ignore
  import mbdAnbieter from '../../assets/Winterkomplettrad Cashback-Aktion 2026 -Anbieter_FINAL.pdf';
  // @ts-ignore
  import mbdTeilnahmebedingungen from '../../assets/Winterräder Cashback-Aktion 2026 - Teilnahmebedingungen_Stand 10-26.pdf';
  import ContactUs from './contact-us.svelte';
  import ThankYouModal from './thank-you-modal.svelte';

  let showContactUs = false;
  let showThankyouMessage = false;
</script>

{#if showContactUs && !showThankyouMessage}
  <ContactUs bind:showContactUs bind:showThankyouMessage />
{:else if showThankyouMessage}
  <ThankYouModal bind:showContactUs bind:showThankyouMessage />
{/if}

<div class="bg-black py-3 sm:py-4">
  <div class="mx-auto max-w-7xl px-3 sm:px-6">
    <div class="flex items-center justify-center gap-6 sm:gap-10">
      <!-- 1) Teilnahmebedingungen -->
      <a
        href={mbdTeilnahmebedingungen}
        target="_blank"
        rel="noopener noreferrer"
        class="font-CorpoS text-xs text-white transition-colors duration-200 hover:text-gray-300 sm:text-sm"
        data-umami-event="Download - Teilnahmebedingungen"
      >
        {$_('Terms and Conditions')}
      </a>

      <span class="text-white opacity-40">•</span>

      <!-- 2) Anbieter (Impressum) -->
      <a
        href={mbdAnbieter}
        target="_blank"
        rel="noopener noreferrer"
        class="font-CorpoS text-xs text-white transition-colors duration-200 hover:text-gray-300 sm:text-sm"
        data-umami-event="Download - Anbieter"
      >
        {$_('Provider')}
      </a>

      <span class="text-white opacity-40">•</span>

      <button
        on:click={() => (showContactUs = true)}
        class="font-CorpoS text-xs text-white transition-colors duration-200 hover:text-gray-300 sm:text-sm"
        data-umami-event="Contact Us"
      >
        {$_('Contact Us')}
      </button>
    </div>
  </div>
</div>
